module.exports = __webpack_public_path__ + "img/undraw_our_solution_htvp.01a06bb0.svg";